import { render } from "./OrderSummaryAsset.vue?vue&type=template&id=38e5f56e&scoped=true&ts=true"
import script from "./OrderSummaryAsset.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryAsset.vue?vue&type=script&lang=ts"

import "./OrderSummaryAsset.vue?vue&type=style&index=0&id=38e5f56e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e5f56e"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
